import { render, staticRenderFns } from "./quote.vue?vue&type=template&id=40ce7d58&scoped=true"
import script from "./quote.vue?vue&type=script&lang=js"
export * from "./quote.vue?vue&type=script&lang=js"
import style0 from "./quote.vue?vue&type=style&index=0&id=40ce7d58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ce7d58",
  null
  
)

export default component.exports